import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss']
})
export class BoxComponent implements OnInit {
  @Input() header: string;

  constructor() {}

  ngOnInit() {}
}
